import type { PBCListParams } from '../../request/pbc/pbcRequests.ts';

/** Query key registry for the PBC (Provided-by-Client) request tracker (Feature 5.3, report #29). */

const pbcRoot = ['pbc'] as const;

export const pbcQueryKeys = {
  all: pbcRoot,
  list: (params: PBCListParams = {}) => [...pbcRoot, 'list', params] as const,
  controlOptions: () => [...pbcRoot, 'control-options'] as const,
} as const;
